<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link :to="{ name: 'terms-of-use'}" class="text-white">Termos de Uso</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'privacy-policy'}" class="text-white">Política de Privacidade</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Preâmbulo Informática S.A.
        <span class="px-1">&middot;</span>
        CNPJ 81.053.092/0001-70
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'MainFooter',
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
